<script setup lang="ts">
const { $axios }: any = useNuxtApp();
import { numberFormatter } from "@/utils/formater";

const collections = ref<any>([]);

const toBikeDetail = (item: any) => {
  useRouter().push(`/bike/${item.slug}`);
};

const toBikes = () => {
  useRouter().push("/bike");
};

const fetchData = async () => {
  try {
    const response = await $axios("/catalog/vehicle?limit=10");
    if (!response || !response.data) throw new Error("No data received");
    collections.value = response.data.data;
  } catch (error) {
    console.error("Error fetching collections:", error);
  }
};

onMounted(() => {
  fetchData();
});
</script>

<template>
  <div class="container px-0 mt-8">
    <ClientOnly>
      <Swiper
        id="swiper-testimonials"
        :modules="[SwiperA11y, SwiperAutoplay, SwiperNavigation]"
        :slides-per-view="3"
        :loop="true"
        :space-between="20"
        class="container !px-0"
        autoplay
        :breakpoints="{
          0: {
            slidesPerView: 1,
          },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }"
      >
        <SwiperSlide
          v-for="(item, i) in collections"
          :key="i"
          class="flex !h-auto bg-transparent pb-2"
        >
          <MazCard variant="flat" class="w-full !bg-white">
            <template #header>
              <div v-if="item.most_popular" class="relative w-full">
                <div
                  class="absolute z-[1] top-[-12px] right-[-16px] bg-yellow-50 text-primary rounded-tr-xl rounded-bl-xl px-6 py-1 flex items-center gap-2 shadow-xl"
                >
                  <Icon name="mdi-star" class="bg-yellow-400" size="24" />
                  <span class="text-sm font-medium">Most Popular</span>
                </div>
                <NuxtImg
                  preset="thumb"
                  :src="item.images[0]"
                  :alt="item.name"
                  class="w-auto w-full h-[300px] object-contain rounded-lg !bg-[#FFF]"
                />
              </div>

              <div v-else-if="item.best_value" class="relative w-full">
                <div
                  class="absolute z-[1] top-[-12px] right-[-16px] bg-primary text-white rounded-tr-xl rounded-bl-xl px-6 py-1 flex items-center gap-2 shadow-xl"
                >
                  <span>💸</span>
                  <span class="text-sm font-medium">Best Value</span>
                </div>
                <NuxtImg
                  preset="thumb"
                  :src="item.images[0]"
                  :alt="item.name"
                  class="w-auto w-full h-[300px] object-contain rounded-lg !bg-[#FFF]"
                />
              </div>

              <NuxtImg
                v-else
                preset="thumb"
                :src="item.images[0]"
                :alt="item.name"
                class="w-auto w-full h-[300px] object-contain rounded-lg !bg-[#FFF]"
              />
            </template>
            <template #content>
              <section class="flex flex-col justify-between">
                <div
                  class="font-bold text-xl text-center w-full h-[56px] leading-[28px] overflow-hidden line-clamp-2 mb-2"
                >
                  {{ item.name }}
                </div>
                <div
                  class="text-ellipsis text-sm min-h-[42px] overflow-hidden line-clamp-2 my-1"
                >
                  {{ item.short_description }}
                </div>
                <div class="border-t border-primary my-2"></div>
                <div class="flex flex-col items-center">
                  <div
                    class="py-2 mb-2 col-span-3 flex text-gray-600 text-sm flex-col items-center"
                  >
                    <span class="font-base">Daily</span>
                    <div>
                      <span class="font-bold text-xl text-black"
                        >Rp.
                        {{ numberFormatter(item.vehicle_rate[0].rate) }}</span
                      >
                      / day
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-2 gap-4">
                  <div
                    class="border-gray-300 border rounded-xl py-3 font-semibold mb-2 text-sm text-primary text-center py-1 flex flex-col items-center"
                  >
                    <span
                      class="bg-primary/30 mb-1 rounded-xl px-4 py-1 text-gray-600"
                    >
                      7+ days</span
                    >
                    <div>
                      <span class="font-base text-primary"
                        >Rp.
                        {{ numberFormatter(item.vehicle_rate[2].rate) }}</span
                      >
                      / day
                    </div>
                  </div>
                  <div
                    class="border-gray-300 border rounded-xl py-3 font-semibold mb-2 text-sm text-center text-primary py-1 flex flex-col items-center"
                  >
                    <span
                      class="bg-primary/30 mb-1 rounded-xl px-4 py-1 text-gray-600"
                    >
                      Monthly</span
                    >
                    <div>
                      <span class="font-base text-primary"
                        >Rp.
                        {{ numberFormatter(item.vehicle_rate[4].rate) }}</span
                      >
                      / day
                    </div>
                  </div>
                </div>
              </section>
              <MazBtn
                v-if="item.is_available"
                block
                class="cursor-pointer mt-4"
                color="primary"
                @click="toBikeDetail(item)"
              >
                View Details
              </MazBtn>
              <div
                v-else
                class="mt-4 bg-gray-200 text-gray-600 items-center flex justify-center font-bold rounded-lg h-11"
              >
                OUT OF STOCK
              </div>
            </template>
          </MazCard>
        </SwiperSlide>
      </Swiper>
    </ClientOnly>

    <div class="w-full flex justify-center mt-8">
      <MazBtn
        color="primary"
        outline
        @click="toBikes"
        class="mt-2 lg:mt-0 min-w-[180px]"
      >
        Go To Collection
        <Icon name="mdi:arrow-right" />
      </MazBtn>
    </div>
  </div>
</template>
